import { AuroraLetterSkin, AuroraSkin, AuroraWrapperSkin } from '../../styles/skins/AuroraSkin';
import { MatrixLetterSkin, MatrixSkin, MatrixWrapperSkin } from '../../styles/skins/MatrixSkin';
import { LightLetterSkin, LightSkin, LightWrapperSkin } from '../../styles/skins/LightSkin';
import {
  CyberpunkLetterSkin,
  CyberpunkSkin,
  CyberpunkWrapperSkin,
} from '../../styles/skins/CyberpunkSkin';
import {
  PastelDreamLetterSkin,
  PastelDreamSkin,
  PastelDreamWrapperSkin,
} from '../../styles/skins/PasteldreamSkin';
import {
  DarkKnightLetterSkin,
  DarkKnightSkin,
  DarkKnightWrapperSkin,
} from '../../styles/skins/DarkknightSkin';
import {
  SunsetGlowLetterSkin,
  SunsetGlowSkin,
  SunsetGlowWrapperSkin,
} from '../../styles/skins/SunsetglowSkin';
import { GardenLetterSkin, GardenSkin, GardenWrapperSkin } from '../../styles/skins/GardenSkin';
import {
  SpaceNebulaLetterSkin,
  SpaceNebulaSkin,
  SpaceNebulaWrapperSkin,
} from '../../styles/skins/SpacenebulaSkin';
import { OceanLetterSkin, OceanSkin, OceanWrapperSkin } from '../../styles/skins/OceanSkin';
import { SkinType } from './skins.types';
import {
  MidnightGlassLetterSkin,
  MidnightGlassSkin,
  MidnightGlassWrapperSkin,
} from '../../styles/skins/MidnightGlassSkin';
import {
  PaperWhiteLetterSkin,
  PaperWhiteSkin,
  PaperWhiteWrapperSkin,
} from '../../styles/skins/PaperWhiteSkin';
import {
  EmberGlowLetterSkin,
  EmberGlowSkin,
  EmberGlowWrapperSkin,
} from '../../styles/skins/EmberGlowSkin';

/**
 * Skin data type for a unified structure
 */
export interface SkinConfig {
  /** Main style for the clock */
  skin: any;
  /** Specific style for letters */
  letterSkin: any;
  /** Specific style for the wrapper */
  wrapperSkin: any;
  /** Display name for UI elements */
  displayName: string;
}

export const SKINS: Record<SkinType, SkinConfig> = {
  aurora: {
    skin: AuroraSkin,
    letterSkin: AuroraLetterSkin,
    wrapperSkin: AuroraWrapperSkin,
    displayName: 'Aurora Borealis',
  },
  midnightGlass: {
    skin: MidnightGlassSkin,
    letterSkin: MidnightGlassLetterSkin,
    wrapperSkin: MidnightGlassWrapperSkin,
    displayName: 'Midnight Glass',
  },
  paperWhite: {
    skin: PaperWhiteSkin,
    letterSkin: PaperWhiteLetterSkin,
    wrapperSkin: PaperWhiteWrapperSkin,
    displayName: 'Paper White',
  },
  emberGlow: {
    skin: EmberGlowSkin,
    letterSkin: EmberGlowLetterSkin,
    wrapperSkin: EmberGlowWrapperSkin,
    displayName: 'Ember Glow',
  },
  matrix: {
    skin: MatrixSkin,
    letterSkin: MatrixLetterSkin,
    wrapperSkin: MatrixWrapperSkin,
    displayName: 'Matrix',
  },
  light: {
    skin: LightSkin,
    letterSkin: LightLetterSkin,
    wrapperSkin: LightWrapperSkin,
    displayName: 'Licht',
  },
  cyberpunk: {
    skin: CyberpunkSkin,
    letterSkin: CyberpunkLetterSkin,
    wrapperSkin: CyberpunkWrapperSkin,
    displayName: 'Cyberpunk',
  },
  pasteldream: {
    skin: PastelDreamSkin,
    letterSkin: PastelDreamLetterSkin,
    wrapperSkin: PastelDreamWrapperSkin,
    displayName: 'Pastelltraum',
  },
  darkknight: {
    skin: DarkKnightSkin,
    letterSkin: DarkKnightLetterSkin,
    wrapperSkin: DarkKnightWrapperSkin,
    displayName: 'Dark Knight',
  },
  sunsetglow: {
    skin: SunsetGlowSkin,
    letterSkin: SunsetGlowLetterSkin,
    wrapperSkin: SunsetGlowWrapperSkin,
    displayName: 'Sonnenuntergang',
  },
  garden: {
    skin: GardenSkin,
    letterSkin: GardenLetterSkin,
    wrapperSkin: GardenWrapperSkin,
    displayName: 'Garten',
  },
  spacenebula: {
    skin: SpaceNebulaSkin,
    letterSkin: SpaceNebulaLetterSkin,
    wrapperSkin: SpaceNebulaWrapperSkin,
    displayName: 'Weltraumnebel',
  },
  ocean: {
    skin: OceanSkin,
    letterSkin: OceanLetterSkin,
    wrapperSkin: OceanWrapperSkin,
    displayName: 'Ozean',
  },
};

export const SKIN_MAP = Object.fromEntries(
  Object.entries(SKINS).map(([key, value]) => [key, value.skin])
);

export const SKIN_LETTER_MAP = Object.fromEntries(
  Object.entries(SKINS).map(([key, value]) => [key, value.letterSkin])
);
